module.exports = __webpack_public_path__ + "img/97.5b29a83d.webp";